import { render, staticRenderFns } from "./help-chat.vue?vue&type=template&id=15f2a940&scoped=true"
import script from "./help-chat.vue?vue&type=script&lang=js"
export * from "./help-chat.vue?vue&type=script&lang=js"
import style0 from "./help-chat.vue?vue&type=style&index=0&id=15f2a940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f2a940",
  null
  
)

export default component.exports